module.exports = __webpack_public_path__ + "static/img/our-people-company-program-hero.3e7de2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-program-hero.jpg
// module id = 5Vny
// module chunks = 0